import { useCookies } from 'react-cookie';
import config from '../config'
import { CookieNames } from '../enums/auth.enum'

const useCustomCookies = () => {

    const [cookies, setCookie, removeCookie] = useCookies([CookieNames.CIGO_SESSION, CookieNames.CIGO_SESSION_PREFIX, CookieNames.LANG]);

    const removeWithOpts = (name: CookieNames | string) => {
        removeCookie(name as any, {
            path: '/',
            domain: config.CIGO_DOMAIN,
        });
    };

    const setCustomCookies = (name: CookieNames, value: string) => {
        setCookie(name, value, {
            sameSite: 'lax',
            secure: true,
            path: '/',
            maxAge: 3600 * 24 * 7,
            domain: config.CIGO_DOMAIN
        });
    };

    const setAuthCookies = (data: any) => {
        removeWithOpts(CookieNames.CIGO_SESSION);
        setCustomCookies(CookieNames.CIGO_SESSION, data.session_uid);
        setCustomCookies(CookieNames.CIGO_SESSION_PREFIX, data.state_prefix);
        setCustomCookies(data.state_prefix as CookieNames, data.state_value);
    }

    const deleteAuthCookies = () => {
        if (cookies[CookieNames.CIGO_SESSION_PREFIX]) {
            removeWithOpts(cookies[CookieNames.CIGO_SESSION_PREFIX]);
        }

        [CookieNames.CIGO_SESSION, CookieNames.CIGO_SESSION_PREFIX].forEach(removeWithOpts);
    }

    return { setAuthCookies, deleteAuthCookies, setCustomCookies, removeCookie };
};

export default useCustomCookies;
